export default "__VITE_ASSET__YuwoqZUM__"